import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { useGlobal } from '../../contexts/Global/context';

function Loading({ props, padding = 24, size = 40, color }) {
    const { contrastTheme } = useGlobal();

    color = !color && !contrastTheme ? '#EC6E0C' : '#FFFFFF';

    return <CircularProgress style={{ height: size, width: size, padding, color, boxSizing: 'initial' }} {...props} />;
}

export default Loading;
